import "../../../src/components/VGrid/_grid.sass";
import "../../../src/components/VGrid/VGrid.sass";
import Grid from './grid';
import mergeData from '../../util/mergeData';
export default Grid('container').extend({
    name: 'v-container',
    functional: true,
    props: {
        id: String,
        tag: {
            type: String,
            default: 'div'
        },
        fluid: {
            type: Boolean,
            default: false
        }
    },
    render(h, { props, data, children }) {
        let classes;
        const { attrs } = data;
        if (attrs) {
            data.attrs = {};
            classes = Object.keys(attrs).filter(key => {
                if (key === 'slot')
                    return false;
                const value = attrs[key];
                if (key.startsWith('data-')) {
                    data.attrs[key] = value;
                    return false;
                }
                return value || typeof value === 'string';
            });
        }
        if (props.id) {
            data.domProps = data.domProps || {};
            data.domProps.id = props.id;
        }
        return h(props.tag, mergeData(data, {
            staticClass: 'container',
            class: Array({
                'container--fluid': props.fluid
            }).concat(classes || [])
        }), children);
    }
});
